import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { BaseComponent } from '@r1-development/rps-shared-ui';
import { filter, takeUntil } from 'rxjs';

export interface BreadcrumbItem {
  label: string;
  routerLink?: string;
  queryParams?: Record<string, string>;
  disabled?: boolean;
}

@Component({
  selector: 'app-breadcrumb',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (breadcrumbs.length > 0) {
      <nav aria-label="breadcrumb" class="cm-breadcrumb px-4 py-1 flex items-center flex-wrap gap-1 text-sm bg-white border-b border-gray-200">
        @for (crumb of breadcrumbs; track crumb.label; let last = $last) {
          @if (!last) {
            @if (crumb.routerLink && !crumb.disabled) {
              <a
                [routerLink]="crumb.routerLink"
                [queryParams]="crumb.queryParams"
                class="text-[#008c95] hover:underline"
              >{{ crumb.label }}</a>
            } @else {
              <span class="text-gray-500">{{ crumb.label }}</span>
            }
            <mat-icon class="text-gray-400 !text-base !w-4 !h-4 leading-none">chevron_right</mat-icon>
          } @else {
            <span class="text-gray-800 font-medium">{{ crumb.label }}</span>
          }
        }
      </nav>
    }
  `,
})
export class BreadcrumbComponent extends BaseComponent implements OnInit {
  breadcrumbs: BreadcrumbItem[] = [];

  constructor(
    private readonly cdr: ChangeDetectorRef,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
  ) {
    super();
  }

  ngOnInit(): void {
    this.readBreadcrumbs();

    this.router.events
      .pipe(
        filter(e => e instanceof NavigationEnd),
        takeUntil(this.destroyed$),
      )
      .subscribe(() => {
        this.readBreadcrumbs();
        this.cdr.markForCheck();
      });
  }

  private readBreadcrumbs(): void {
    let child = this.route.root;
    while (child.firstChild) {
      child = child.firstChild;
    }
    this.breadcrumbs = child.snapshot.data?.['breadcrumbs'] ?? [];
  }
}
